import { useState, useEffect } from 'react';
import { orgAPI } from '../services/api';

// Capability map — mirrors backend permissions.middleware.js exactly.
const CAPABILITIES = {
  dashboard    : ['owner', 'admin', 'viewer', 'monitor', 'billing', 'support'],
  opsView      : ['owner', 'admin', 'viewer', 'support'],
  opsEdit      : ['owner', 'admin', 'support'],
  monitorView  : ['owner', 'admin', 'viewer', 'monitor', 'support'],
  costView     : ['owner', 'admin', 'viewer', 'billing'],
  billingAction: ['owner', 'admin', 'billing'],
  team         : ['owner', 'admin'],
};

export function useOrgRole() {
  const [role, setRole] = useState(null);       // null = solo account, unrestricted
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    orgAPI.me()
      .then(r => {
        if (cancelled) return;
        if (r.data.success && r.data.data) {
          setRole(r.data.data.role);
          setOrganization(r.data.data.organization);
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const can = (action) => {
    if (!role) return true; // solo accounts: unrestricted
    return (CAPABILITIES[action] || []).includes(role);
  };

  return { role, organization, loading, can };
}
